import { Dialog, DialogContent, DialogTitle, MenuItem, Typography, useTheme } from '@mui/material';
import React, { PropsWithChildren, useState } from 'react';
import { Iconic } from '../iconic';

type Props = {
  text: string;
  title: string;
  icon: string;
  component: any;
  disabled?: boolean;
};

const DialogMenu = ({
  title,
  text,
  icon,
  children,
  component,
  disabled,
}: PropsWithChildren<Props>) => {
  const [open, setOpen] = useState(false);
  const { typography } = useTheme();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const onClose = (_value: string) => {
    setOpen(false);
  };
  return (
    <>
      <MenuItem onClick={handleClickOpen} disabled={disabled}>
        <Iconic icon={icon} />
        {text}
      </MenuItem>
      <Dialog onClose={onClose} open={open} maxWidth="sm" fullWidth>
        <DialogTitle>
          <Typography sx={{ ...typography.h6 }} textAlign="center">
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent
          sx={{
            flexDirection: 'row',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around',
          }}
        >
          {children}
          {component({ open, onClose })}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DialogMenu;
